import * as deepmerge_ from 'deepmerge';
import * as getValue_ from 'get-value';
import * as hashObject_ from 'object-hash';
import * as setValue_ from 'set-value';

export const getValue = getValue_;
export const setValue = setValue_;
export const deepmerge = deepmerge_;
export const hashObject = hashObject_;
